export default __webpack_public_path__ + "static/media/passion-points.png";